import React from "react";

function DataCard({ title, value, icon }) {
  return (
    <section className="sm:border p-2 sm:p-5 rounded-[15px] sm:shadow-md sm:hover:shadow-lg cursor-pointer">
      <div className="flex w-full justify-between items-center">
        <h3 className="text-[14px] sm:text-[16px] text-slate-500">{title}</h3>
        <span className="text-[18px] text-slate-700 hidden sm:flex">{icon}</span>
      </div>
      <p className="text-[18px] sm:text-[32px] mt-1 font-semibold">{value}</p>
    </section>
  );
}

export default DataCard;
